/**
 * Recursive deep merge of two objects.
 * Source: https://youmightnotneedjquery.com/
 * @param target - "Our" object
 * @param source - "Incoming" object
 */
export const deepMerge = (target, source) => {
    if (!target || typeof target !== 'object')
        return {};
    if (!source || typeof source !== 'object')
        return target;
    for (const [key, value] of Object.entries(source)) {
        switch (Object.prototype.toString.call(value)) {
            case '[object Object]':
                target[key] = target[key] || {};
                target[key] = deepMerge(target[key], value);
                break;
            case '[object Array]':
                target[key] = deepMerge(new Array(value.length), value);
                break;
            default:
                // Functions, primitives
                target[key] = value;
        }
    }
    return target;
};
